<template>
  <Row id="Plan">
    <Col :span="24" class="title">
      <TypographyTitle>{{$t('nav.name.PlanManage')}}</TypographyTitle>
    </Col>
    <Col :span="24" class="content">
      <Row :gutter="[16,32]">
        <Col :span="24" >
          <Form :model="searchForm">
            <Row :gutter="30">
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('plan.name.company')">
                  <Select v-model:value="searchForm.idSerPro" :placeholder="$t('public.placeholder.please_select')" :filter-option="filterOption"
                      show-search>
                    <SelectOption :value="null" title="All">{{ $t('public.name.all') }}</SelectOption>
                    <SelectOption v-for="(item) in selectList.serviceProviderList" :title="item['companyName']" :value="item.idSerPro">{{ item.companyName}}</SelectOption>
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('public.name.search')" name="search">
                  <Input :placeholder="$t('public.name.search')" v-model:value="searchForm.search"></Input>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('public.field.status')">
                  <Select v-model:value="searchForm.status" :placeholder="$t('public.placeholder.please_select')">
                    <SelectOption :value="null">{{ $t('public.name.all') }}</SelectOption>
                    <SelectOption :value="0">{{ $t('public.status.4') }}</SelectOption>
                    <SelectOption :value="1">{{ $t('public.status.5') }}</SelectOption>
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8" class="text-right">
                <Button type="primary" @click="search_submit">{{$t('public.name.search')}}</Button>&nbsp;
                <Button @click="search_reset">{{$t('public.name.reset')}}</Button>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col :span="24">
        <Table :columns="columns" :dataSource="list" :scroll="{ x: true }" rowKey="idPla" :loading="loading" :pagination="tablePagination" @change="chang_page">
            <template #actionTitle>
              <span>
                {{$t("public.table.action")}}
                <Button v-if="checkPermission('PlanManage.Add')" type="primary" size="small" shape="circle" @click="add()">
                  <PlusOutlined />
                </Button>
              </span>
            </template>
            <template #action="{text}">
              <div>
                <div class="pc-display">
                  <Button type="default" size="small" @click="detail(text)">{{$t("public.name.detail")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('PlanManage.Edit')" type="primary" size="small" @click="edit(text)">{{$t("public.name.edit")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('PlanManage.Delete')" type="primary" danger size="small" @click="del(text.idPla)">{{$t("public.name.del")}}</Button>
                </div>
                <Dropdown :trigger="['click']" class="wap-display">
                  <template #overlay>
                    <Menu>
                      <MenuItem @click="del(text.id)">{{$t('public.name.del')}}</MenuItem>
                    </Menu>
                  </template>
                  <Button size="small">
                    {{$t("public.name.more")}}
                    <DownOutlined />
                  </Button>
                </Dropdown>
              </div>
            </template>
          </Table>
        </Col>
      </Row>
    </Col>
    <PlanDetail ref="refPlanDetail"></PlanDetail>
    <PlanEdit ref="refPlanEdit" @updateList="get_list"></PlanEdit>
  </Row>
</template>

<script>
import { createVNode } from "vue";
import { Row, Col, Table, Typography, Tag, Button, Dropdown, Menu, Modal, Form, Input, Select, message } from "ant-design-vue";
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { PlanList } from "@/api/PlanList";
import { PlanDelete } from "@/api/PlanDelete"
import { ServiceProviderListAll } from "@/api/ServiceProviderListAll"
import PlanDetail from "@/components/Home/PlanDetail";
import PlanEdit from "@/components/Home/PlanEdit";
import moment from "moment";

export default {
  name: "PlanManage",
  components: {
    Row,
    Col,
    Table,
    Form,
    FormItem: Form.Item,
    TypographyTitle: Typography.Title,
    Tag,
    Button,
    Input,
    Select,
    SelectOption: Select.Option,
    Dropdown,
    DownOutlined,
    PlusOutlined,
    ExclamationCircleOutlined,
    Menu,
    MenuItem: Menu.Item,
    PlanDetail,
    PlanEdit,
  },
  data() {
    return {
      searchForm: {
      },
      tablePagination: {
        pageSizeOptions: ["10", "20", "50", "100"],
        showSizeChanger: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
      list: [],
      columns: [
          // { title: this.$t("plan.table.id_pla"), fixed: "left", dataIndex: "idPla", key: "idPla" },
          { title: this.$t("plan.table.id_ser_pro"), dataIndex: "serviceProviderCompanyName", key: "serviceProviderCompanyName" },
          { title: this.$t("plan.table.id_pla_cat"), dataIndex: "planCategoryCategoryName", key: "planCategoryCategoryName" },
          // { title: this.$t("plan.table.id_ins_com"), dataIndex: "insuranceCompanyCompanyName", key: "insuranceCompanyCompanyName" },
          { title: this.$t("plan.table.plan_name_hk"), dataIndex: "planNameHk", key: "planNameHk" },
          { title: this.$t("plan.table.plan_name"), dataIndex: "planName", key: "planName" },
          { title: this.$t("plan.table.plan_code"), dataIndex: "planCode", key: "planCode" },
          { title: this.$t("plan.table.create_date"), dataIndex: "createDate", key: "createDate" },
          { title: this.$t("plan.table.status"), dataIndex: "status", key: "status", customRender: ({text}) =>{
              return this.selectList.statusList.find(item=>item.value===text).label
            }
          },
          { title: this.$t("plan.table.adjust_afyp_rate"), dataIndex: "adjustAfypRate", key: "adjustAfypRate" , customRender: ({text}) =>{return text + '%'}},
          { title: this.$t("plan.table.expiry_date"), dataIndex: "expiryDate", key: "expiryDate", customRender: ({text}) =>{return moment(text).format('YYYY-MM-DD')}},
          { title: this.$t("plan.table.plan_code_print"), dataIndex: "planCodePrint", key: "planCodePrint" },
        { key: "action", fixed: "right", slots: { title: "actionTitle", customRender: "action" } },
      ],
      selectList:{
        serviceProviderList: [],
        planCategoryList: [],
        statusList: [{value: 0,label: 'Off'},{value:1,label: 'On'}],
      }
    };
  },
  methods: {
    chang_page(pagination) {
      this.tablePagination = pagination;
      this.get_list();
    },
    get_list() {
      this.loading = true;
      const api = new PlanList();
      const getData = {
        page: this.tablePagination.current,
        limit: this.tablePagination.pageSize,
      }
      if (this.searchForm.search != "") getData.search = this.searchForm.search
      if (this.searchForm.status != undefined) getData.status = this.searchForm.status
      if (this.searchForm.idSerPro != undefined) getData.idSerPro = this.searchForm.idSerPro
      api
        .get(getData)
        .then((response) => {
          this.loading = false;
          if (0 === parseInt(response.data.code)) {
            const dataTmp = response.data.data;
            this.tablePagination.current = parseInt(dataTmp.current);
            this.tablePagination.pageSize = parseInt(dataTmp.pageSize);
            this.tablePagination.total = parseInt(dataTmp.total);
            this.list = dataTmp.data;
          } else {
            this.list = [];
          }
        });
    },
    add() {
      this.$refs.refPlanEdit.addShow();
    },
    detail(obj) {
      this.$refs.refPlanDetail.detailShow(obj);
    },
    edit(obj) {
      this.$refs.refPlanEdit.editShow(obj);
    },
    del(idPla) {
      Modal.confirm({
        title: this.$t("public.name.are_you_sure_delete") + "?",
        content: this.$t("public.name.action_cannot_resumed"),
        icon: createVNode(ExclamationCircleOutlined),
        okText: this.$t("public.name.yes"),
        okType: "danger",
        cancelText: this.$t("public.name.no"),
        onOk: () => {
          const api = new PlanDelete();
          api.post({ idPla: idPla }).then((response) => {
            if (0 === parseInt(response.data.code)) {
              this.get_list();
              message.success(response.data.msg);
            } else {
              message.error(response.data.msg);
            }
          });
        },
      });
    },
    getServiceProviderList() {
      const api = new ServiceProviderListAll();
      api.get().then((response) => {
        if (0 == parseInt(response.data.code)) {
            this.selectList.serviceProviderList = response.data.data;
        } else {
            message.error(response.data.msg);
        }
      });
    },
    search_submit() {
      this.get_list()
    },
    search_reset() {
      this.searchForm = {
        // search: "",
        // status: 0,
        // order: "",
      }
      this.get_list()
    },
    filterOption(input, option) {
    // console.log("option.title.toLowerCase()：" + option.title.toLowerCase());
    // console.log("input.toLowerCase()：" + input.toLowerCase());
    // console.log("option.title.toLowerCase().indexOf(input.toLowerCase())：" + option.title.toLowerCase().indexOf(input.toLowerCase()));
    return option.title.toLowerCase().indexOf(input.toLowerCase()) != -1;
  }, 
  },
  mounted() {
    this.get_list();
    this.getServiceProviderList();
  },
}
</script>

<style lang="less">
@import url("~@/assets/less/home/plan.less");
</style>